import { FormStore } from './types';

// Необходимо, чтобы учитывать уже созданные формы и не создавать новый стор для них
export const storeManager = new Map<string, FormStore>();
